import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { select, Store } from '@ngrx/store';
import {
  Select2UpdateEvent,
  Select2UpdateValue
} from 'ng-select2-component';
import { combineLatest, Observable, Subscription } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';
import { AuthService } from 'src/app/core/services/auth.service';
import { RouteService } from 'src/app/core/services/route.service';
import { LoadFields } from 'src/app/core/state/_actions/field.actions';
import * as moment from 'moment';
import {
  GetFormFieldUsers,
  GetRelatedData,
  LoadFormSavedFields,
} from 'src/app/core/state/_actions/form.actions';
import { LoadCompanyUsers, LoadEntityUsers } from 'src/app/core/state/_actions/settings/application-users.actions';
import { LoadUsers } from 'src/app/core/state/_actions/user.actions';
import { CompanyUsers } from 'src/app/core/state/_models/settings.models';
import {
  getApplicationById
} from 'src/app/core/state/_selectors/application.selector';
import {
  getFormFieldUsers,
  getFormFieldUsersLoading,
  getRelatedData,
} from 'src/app/core/state/_selectors/form.selector';
import { getCompanyUsers } from 'src/app/core/state/_selectors/settings/application-users.selector';
import { getUsers } from 'src/app/core/state/_selectors/user.selector';
import { ActionsComponent } from '../../../../modules/application/report/view/field/actions/actions.component';
import { CommonService } from 'src/app/core/services/common.service';
import { DROPDOWN_VALUE_PLACEHOLDER, SELECT_LOADER } from 'src/app/shared/constants';
import { SubSink } from 'subsink';
import { CompanyService } from 'src/app/core/state/_services/company.service';
import { LaunchDarklyService } from 'src/app/core/services/launchdarkly.service';
import { FEATURE_FLAGS } from 'src/app/shared/launchdarkly.constants';
import { LDFlagValue } from 'launchdarkly-js-client-sdk';
@Component({
  selector: 'app-select-search-scroll',
  templateUrl: './select-search-scroll.component.html',
  styleUrls: ['./select-search-scroll.component.scss'],
  host: {
    '[class.accessibility-enabled]': 'enableDataTableAccessibilityValue',
    '[class.form-dropdown-ng-select-enabled]': 'enableFormDropdownNgSelectValue'
  }
})
export class SelectSearchScrollComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input('isConditionComponent') isConditionComponent: boolean = false;
  @Input('isSubscriptionComponent') isSubscriptionComponent: boolean = false;
  @Input('isAddExistingUserComponent') isAddExistingUserComponent: boolean =
    false;
  @Input('isRelatedDataComponent') isRelatedDataComponent: boolean = false;
  @Input('options') options: Array<any> = [];
  @Input('extraOptions') extraOptions: Array<any> = [];
  @Input('searchable') searchable: boolean = false;
  @Input('scrollable') scrollable: boolean = false;
  @Input('minSearchLength') minSearchLength: number = 0;
  @Input('virtualScroll') virtualScroll = false;
  @Input('form') form!: UntypedFormGroup;
  @Input('label') label!: string;
  @Input('infoText') infoText!: string;
  @Input('error') error: string = 'This field is required';
  @Input('controlName') controlName: string = '';
  @Input('multiple') multiple: boolean = false;
  @Input('disabled') disabled: boolean = false;
  @Input('canClear') canClear: boolean = false;
  @Input('nullPlaceholder') nullPlaceholder: string = SELECT_LOADER;
  @Output('selected') selected = new EventEmitter<any>();
  @Output('relatedSelected') relatedSelected = new EventEmitter<any>();
  @Input() requiredMark: boolean = false;
  @Input('isHeader') isHeader: boolean = false;
  @Input('IsFormFieldNameHidden') IsFormFieldNameHidden: boolean = false;
  @Input('IsFromForm') IsFromForm:boolean = false;
  @Input('IsInfoVisible') IsInfoVisible:boolean = true;
  @Input('DisplayOnScreen') DisplayOnScreen:boolean = false;
  @Input('AllowMinimize') AllowMinimize:boolean = false;
  @Input('IsRowDisplayOnScreen') IsRowDisplayOnScreen:boolean = false;
  @Input('fromSMSNotification') fromSMSNotification: boolean = false;
  @Input('closeOnSelect') closeOnSelect: boolean = true;
  @Input('relatedFieldKey') relatedFieldKey: string = '';
  @Input('passedTableKey') passedTableKey: string = '';
  @Input('isFormAction') isFormAction: boolean = false;
  @Input('defaultSelectionLabel') defaultSelectionLabel: string | null = null;
  @Input('modalLayer') modalLayer: number = 0;
  @Input('relatedTableId') relatedTableId: string = '';
  @Input('relatedFormId') relatedFormId: string = '';
  @Input('dropdownFieldKey') dropdownFieldKey: string = '';
  @Input('dependentFieldKey') dependentFieldKey: string = '';
  @Input('dependentFieldValue') dependentFieldValue: any = 0;
  @Input('restrictConditions') restrictConditions: any = null;
  @Input('isSelectDisabled') isSelectDisabled: boolean = false;
  @Input('fetchFromServer') fetchFromServer:boolean = false;
  @Input('selectedValue') selectedValue:string = '';
  @Input('isDelayInCall') isDelayInCall: boolean = false;
  @Input('isCustomDropdown') isCustomDropdown: boolean = false;
  @Input('selectedValueId') selectedValueId: any = null;
  @Input('dropdownType') dropdownType:string = '';
  @Input('accessibleLabel') accessibleLabel: string = 'Select option';
  @Input('staticOptions') staticOptions: boolean = false;
  @Input('errorMessagePrefix') errorMessagePrefix: string = '';
  @Input('showItemRemove') showItemRemove: boolean = false;

  isTextVisible:boolean = true
  isDependentValueUpdate: boolean =false;
  companyId: string = '0';
  value:any = '';
  initialOptions: Array<any> = [];
  selectId: string = '';
  errorId: string = '';
  selectionAnnouncement: string = '';

  // @Output('clear') clear = new EventEmitter<void>();

  currentSearch: string = '';
  currentSize: number = 0;
  isScrolled: boolean = false;
  scrollCount: number = 1;
  timeout: any = null;
  required = false;
  isMoreData:boolean = true;
  validator = Validators.required;
  subsink: SubSink = new SubSink();
  tablekey:string = '';
  isFormFieldUsersLoading:{[key:string]:boolean} = {};
  private subscriptions: Subscription[] = []; // Array to store subscriptions
  initialPageSize: number = 20;
  isDecreaseSkip: boolean = false;
  localDateFormat:string = '';
  localDatetimeFormat:string = '';
  entityFriendlyId: string | null = null;
  entityUuid: string | null = null;
  private readonly SEARCH_PAGE_SIZE: number = 10;

  // Feature flag for accessibility
  enableDataTableAccessibility$!: Observable<LDFlagValue>;
  enableDataTableAccessibilityValue: boolean = false;
  enableFormDropdownNgSelect$!: Observable<LDFlagValue>;
  enableFormDropdownNgSelectValue: boolean = false;
  showEnhancedTemplate$!: Observable<boolean>;

  constructor(
    private store: Store,
    private routeService: RouteService,
    private authService: AuthService,
    private cdr: ChangeDetectorRef,
    private modal: NgbModal,
    private readonly common: CommonService,
    private readonly companyService: CompanyService,
    private readonly ldService: LaunchDarklyService,
    private readonly el: ElementRef
  ) { }

  ngOnInit(): void {
    // Initialize feature flag observable
    this.enableDataTableAccessibility$ = this.ldService.getFlagValue(
      FEATURE_FLAGS.ENABLE_DATA_TABLE_ACCESSIBILITY,
      false
    );

    // Subscribe to get synchronous value for logic
    this.subsink.add(
      this.enableDataTableAccessibility$.subscribe((value) => {
        this.enableDataTableAccessibilityValue = !!value;
      })
    );

    this.enableFormDropdownNgSelect$ = this.ldService.getFlagValue(
      FEATURE_FLAGS.ENABLE_FORM_DROPDOWN_NG_SELECT,
      false
    );
    this.subsink.add(
      this.enableFormDropdownNgSelect$.subscribe((value) => {
        this.enableFormDropdownNgSelectValue = !!value;
      })
    );

    this.showEnhancedTemplate$ = combineLatest([
      this.enableDataTableAccessibility$,
      this.enableFormDropdownNgSelect$
    ]).pipe(
      map(([dt, fd]) => !!dt || !!fd)
    );

    this.selectId = `select-search-scroll-${Math.random().toString(36).substring(2, 11)}`;
    this.errorId = `error-${this.selectId}`;

    this.tablekey = this.passedTableKey || this.routeService.getTableKey();
    this.getApiState();
    this.detectLocalFormats();
    if(this.isCustomDropdown){
      this.selectedLabel = this.options.find(option => option.value === this.control.value)?.label;
    }
    // this.store.dispatch(new LoadApplicationById(this.routeService.getApplicationId()));
    this.loadSubscribers();
    if (this.isRelatedDataComponent && (!this.options.length || this.fetchFromServer)) {
      this.fetchFromServer = false;
      var tableId = this.passedTableKey || this.routeService.getTableKey();
      if (this.dependentFieldKey !== '' && this.dependentFieldValue !== 0) {
        this.store.dispatch(
          new GetRelatedData(
            tableId,
            this.form?.value?.FieldKey || this.relatedFieldKey,
            this.form?.value?.DropdownLabelKey || this.dropdownFieldKey || '',
            false,
            '',
            false,
            0,
            20,
            true,
            +this.dependentFieldValue,
            this.dependentFieldKey,
            this.restrictConditions
          )
        );
      }
      else {
        if(this.isDelayInCall){
          setTimeout(()=>{
            this.getRelatedDataOnInIt(tableId)
          },300)
        }
        else{
          this.getRelatedDataOnInIt(tableId)
        }
      }
    }

    if (!this.options.length) {
      this.options = [{value:'', label:SELECT_LOADER}];
    } else if (
      !this.multiple &&
      this.options[0]?.value !== '' &&
      this.options[0]?.label !== DROPDOWN_VALUE_PLACEHOLDER
    ) {
      this.options = [{ value: '', label: DROPDOWN_VALUE_PLACEHOLDER, disabled: this.isSelectDisabled }, ...this.options];
    }
    if (this.isSubscriptionComponent) {
      this.store.dispatch(
        new LoadUsers(
          this.routeService.getApplicationKey(),
          false,
          '',
          false,
          0,
          0,
          true
        )
      );
    }
    if (this.isAddExistingUserComponent) {
      this.subsink.add(
        this.store.pipe(
          select(getApplicationById),
          filter((apps) => !!apps[this.routeService.getApplicationKey()]),
          map((apps) => apps[this.routeService.getApplicationKey()]),
          filter((app) => !!app?.CompanyKey),
          switchMap((app) => this.companyService.getCompany(app.CompanyKey)),
          map((company) => ({
            entityFriendlyId: company?.EntityFriendlyId ?? null,
            entityUuid: company?.EntityUuid ?? null
          }))
        ).subscribe(({ entityFriendlyId, entityUuid }) => {
          this.entityFriendlyId = entityFriendlyId;
          this.entityUuid = entityUuid;

          if (this.entityFriendlyId && this.entityUuid) {
            this.store.dispatch(
              new LoadEntityUsers(this.entityUuid, '', 0, this.SEARCH_PAGE_SIZE)
            );
          } else {
            this.store.dispatch(
              new LoadCompanyUsers(
                this.companyId,
                this.routeService.getApplicationKey(),
                false,
                '',
                false,
                0,
                0,
                true
              )
            );
          }
        })
      );
    }
    if (this.isConditionComponent) {
      // this.options = [];
      var tableId = this.passedTableKey || this.routeService.getTableKey();
      // if (isNaN(tableId)) {
      //   tableId = 0;
      // }
      this.store.dispatch(
        new GetFormFieldUsers(
          tableId,
          this.routeService.getApplicationKey(),
          this.routeService?.paramMap?.formId || '',
          this.form?.value?.Id || '',
          false,
          '',
          false,
          0,
          0,
          true,
          this.fromSMSNotification
        )
      );
    }
    if (this.form?.value?.Value) {
      let index = this.options.findIndex((i) => {
        return i.value === this.form.value.Value;
      });
      if (index == -1) {
        let temp = [
          { label: '', value: '' },
          { label: this.form.value.Value, value: this.form.value.Value },
        ];
        this.options.splice(0, 1);
        temp.push(...this.options);
        this.options = temp;
      }
    }

    if (this.control?.errors?.required === true ) this.required = true;
    this.updateSelectionAnnouncement();
  }
  getRelatedDataOnInIt(tableId: string,isConditionComponent: boolean = true) {
    this.store.dispatch(
      new GetRelatedData(
        tableId,
        this.form?.value?.FieldKey || this.relatedFieldKey,
        this.form?.value?.DropdownLabelKey || this.dropdownFieldKey || '',
        false,
        '',
        false,
        0,
        20,
        isConditionComponent,
        0,
        '',
        this.restrictConditions,
        this.selectedValueId
      )
    );
  }

  ngAfterViewInit(): void {
    this.enhanceClearButtonA11y();
    this.patchComboboxAriaControls();
  }

  private enhanceClearButtonA11y(): void {
    if (!this.enableFormDropdownNgSelectValue) return;
    setTimeout(() => {
      const clearWrappers = this.el.nativeElement.querySelectorAll('.ng-clear-wrapper:not([role])');
      clearWrappers.forEach((wrapper: HTMLElement) => {
        wrapper.setAttribute('tabindex', '0');
        wrapper.setAttribute('role', 'button');
        wrapper.setAttribute('aria-label', 'Clear selection');
        wrapper.addEventListener('click', () => {
          this.focusDropdownInput();
        });
        wrapper.addEventListener('keydown', (e: KeyboardEvent) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            e.stopPropagation();
            this.handleClearViaKeyboard();
          }
        });
      });
    });
  }

  private handleClearViaKeyboard(): void {
    if (this.form) {
      this.control.setValue(this.multiple ? [] : null);
    } else {
      this.selectedValue = '';
    }
    this.onClear(!this.form);
    this.cdr.detectChanges();
    this.focusDropdownInput();
  }

  private focusDropdownInput(): void {
    setTimeout(() => {
      const input = this.el.nativeElement.querySelector('.ng-input input');
      if (input) {
        input.focus();
      }
    });
  }

  private patchComboboxAriaControls(): void {
    if (!this.enableFormDropdownNgSelectValue) return;
    const observer = new MutationObserver(() => {
      const comboboxes = this.el.nativeElement.querySelectorAll('.ng-input[role="combobox"]');
      comboboxes.forEach((cb: HTMLElement) => {
        const ownsId = cb.getAttribute('aria-owns');
        if (ownsId && cb.getAttribute('aria-controls') !== ownsId) {
          cb.setAttribute('aria-controls', ownsId);
        }
      });
    });
    observer.observe(this.el.nativeElement, { attributes: true, subtree: true, attributeFilter: ['aria-owns'] });
    this.subsink.add({ unsubscribe: () => observer.disconnect() });
  }

  ngOnChanges(changes: SimpleChanges) {
    this.handleExtraOptionsChange(changes);
    this.handleSMSNotificationChange(changes);
    this.handleDependentFieldValueChange(changes);

    if (this.control?.errors?.required === true) this.required = true;
    const disabled = changes?.disabled?.currentValue;
    const isHeader = changes?.isHeader?.currentValue;
    if (disabled === true || isHeader === true) {
      this.required = false;
      this.control?.disable();
    } else if (disabled === false && !this.isHeader) {
      this.control?.enable();
    }
  }

  private handleExtraOptionsChange(changes: SimpleChanges): void {
    if (!changes.extraOptions || changes.extraOptions.previousValue === changes.extraOptions.currentValue) return;
    let previousOptions = [...this.options];
    if (previousOptions.length) {
      changes.extraOptions.currentValue.forEach((extraOption: any) => {
        if (!previousOptions.find(option => option.value === extraOption.value)) {
          previousOptions.push(extraOption);
        }
      });
    } else {
      previousOptions.push(...changes.extraOptions.currentValue);
    }
    this.options = previousOptions;
    this.updateSelectionAnnouncement();
  }

  private handleSMSNotificationChange(changes: SimpleChanges): void {
    if (!changes.fromSMSNotification || changes.fromSMSNotification.previousValue === changes.fromSMSNotification.currentValue) return;
    if (this.fromSMSNotification) {
      this.form?.controls[this.controlName].setValue(null);
      this.isScrolled = false;
    }
    this.store.dispatch(
      new GetFormFieldUsers(
        this.passedTableKey || this.routeService.getTableKey(),
        this.routeService.getApplicationKey(),
        this.routeService.paramMap.formId,
        this.form.value.Id,
        false,
        '',
        false,
        0,
        0,
        true,
        this.fromSMSNotification
      )
    );
  }

  private handleDependentFieldValueChange(changes: SimpleChanges): void {
    if (!changes.dependentFieldValue) return;
    const { previousValue, currentValue } = changes.dependentFieldValue;
    if (previousValue === undefined && currentValue === '') {
      this.isDependentValueUpdate = true;
    }
    if (previousValue !== undefined && previousValue !== 0 && (previousValue || previousValue === '') && !this.isDependentValueUpdate && !!currentValue && previousValue !== currentValue) {
      this.form?.controls[this.controlName].setValue('');
    }
    if (previousValue === '') {
      this.isDependentValueUpdate = false;
    }
  }

  get control() {
    return this.form?.controls[this.controlName] || {};
  }

  /** Stable id for combobox hint text (referenced by search input aria-describedby). */
  get comboHintId(): string {
    return `${this.selectId}-combo-hint`;
  }

  /** Instructions for the combobox search field (WCAG: combobox pattern). */
  get comboHintText(): string {
    if (this.isSearchable()) {
      return 'To search within options, type in this field.';
    }
    return 'Use arrow keys to open the list and choose an option.';
  }

  /**
   * Applied to ng-select's internal search input via inputAttrs so VoiceOver announces
   * a combobox (not a plain text field) and the hint is read after the accessible name.
   */
  get ngSelectInputAttrs(): { [key: string]: string } {
    const name = (this.label || this.accessibleLabel || 'Select').trim();
    const hasError = this.control && 'dirty' in this.control
      && this.control.dirty && this.control.errors && this.control.touched;
    const describedBy = hasError
      ? `${this.comboHintId} ${this.errorId}`
      : this.comboHintId;
    const attrs: { [key: string]: string } = {
      'aria-label': `${name}, combobox`,
      'aria-describedby': describedBy,
    };
    if (this.required) {
      attrs['aria-required'] = 'true';
    }
    if (hasError) {
      attrs['aria-invalid'] = 'true';
    }
    return attrs;
  }

  getApiState(){
    const combinedSubscription =  this.store.select(getFormFieldUsersLoading).subscribe((data)=>{
      this.isFormFieldUsersLoading = data;
    })
    this.subsink.add(combinedSubscription);
  }

  /**
   * Get state if data is loaded or not
   * @returns true if loading
   */
  isOptionLoading = () => this.options?.length === 0 || this.options[0].label == SELECT_LOADER;

  /**
   * Options for select
   * @returns options
   */
  getOptions = () => (this.options ? this.options : []);

  /**
   * Placeholder 'Select..' if options is null
   * @returns placeholder
   */
  getPlaceholder = () =>
    this.isOptionLoading() || !this.options ? this.nullPlaceholder : DROPDOWN_VALUE_PLACEHOLDER;

  selectedLabel:string = ''
  /**
   * On change event
   */
  change = (event: Select2UpdateEvent<Select2UpdateValue>) => {
    if (event) {
      if (event && event.value === 'clickRelated') {
        this.control.setValue(this.isFormAction ? '' : null);
        this.openRelatedModal();
      }
      if (!this.multiple && event.value === '' && this.enableFormDropdownNgSelectValue) {
        this.control.setValue(null);
        this.selected.emit(event);
        this.updateSelectionAnnouncement();
        return;
      }
      this.selected.emit(event);
      if (this.disabled) this.control.disable();
      this.selectedLabel = this.options.find(option => option.value === event.value)?.label;
      this.updateSelectionAnnouncement();
      this.enhanceClearButtonA11y();
    }
  };

  updateSelectionAnnouncement(): void {
    const controlValue = this.control?.value;
    if (this.multiple) {
      if (Array.isArray(controlValue) && controlValue.length > 0) {
        const labels = controlValue
          .map((val: any) => this.options.find(o => o.value === val)?.label)
          .filter(Boolean);
        this.selectionAnnouncement = labels.length
          ? `${labels.join(', ')} selected`
          : 'No options selected';
      } else {
        this.selectionAnnouncement = 'No options selected';
      }
    } else {
      if (controlValue != null && controlValue !== '') {
        const match = this.options.find(o => o.value === controlValue);
        this.selectionAnnouncement = match?.label
          ? `${this.getFormattedLabel(match.label)} selected`
          : 'No option selected';
      } else {
        this.selectionAnnouncement = 'No option selected';
      }
    }
  }

  isOptionSelected(item: any): boolean {
    const controlValue = this.control?.value;
    if (this.multiple && Array.isArray(controlValue)) {
      return controlValue.includes(item.value);
    }
    return controlValue === item.value;
  }

  /**
   * Open popup for adding a parent table record
   */
  openRelatedModal = async (opType: string = '') => {
    this.store.dispatch(new LoadFields(this.routeService.getTableKey()));
    let modalRef = this.modal.open(ActionsComponent, {
      windowClass: 'modal-custom modal-padding',
      centered: true,
      size: 'xl',
      backdrop: 'static',
      animation: true,
      keyboard: false,
    });

    modalRef.componentInstance.relatedTableKey = this.relatedTableId;
    modalRef.componentInstance.relatedFormKey = this.relatedFormId;
    modalRef.componentInstance.modalLayer = this.modalLayer + 1;
    modalRef.componentInstance.isInModal = true;
    modalRef.componentInstance.isRelatedOptionAdding = true;
    modalRef.componentInstance.reportName = this.defaultSelectionLabel;
    await modalRef.result
      .then((value) => {
        this.loadMoreRelatedData();
      })
      .catch((reason) => {
        if(reason.includes('Submit')){
          this.common.newRelatedRecordValue = reason.split('_')[1];;
          var tableId = this.passedTableKey || this.routeService.getTableKey();
          this.store.dispatch(
            new GetRelatedData(
              tableId,
              this.form?.value?.FieldKey || this.relatedFieldKey,
              this.form?.value?.DropdownLabelKey || this.dropdownFieldKey || '',
              false,
              '',
              false,
              0,
              10,
              false,
              +this.common.newRelatedRecordValue || 0,
              this.dependentFieldKey || '',
              this.restrictConditions
            )
          );
        }
        // this.loadMoreRelatedData();
      });
  };

  loadMoreRelatedData(){
    this.store.dispatch(
      new LoadFormSavedFields(
        this.routeService.getTableKey(),
        this.routeService.paramMap.formId
      )
    );
    this.isMoreData = true;
  };

  // clearSelect = () => {
  //   this.clear.emit();
  // };

  isSearchable = () => {
    return this.searchable;
  };

  isVirtualScroll = () => {
    return this.virtualScroll;
  };

  onScroll(event: any) {
    if (!this.scrollable) {
      return;
    }
  }

  onScrollToEnd() {
    if (this.staticOptions) return;
    if (this.scrollCount++ == 0 && !this.scrollable) return;
    this.isScrolled = true;
    var tableId = this.passedTableKey|| this.routeService.getTableKey();
    if(!this.currentSize && this.selectedValueId && this.options.length-1 > this.initialPageSize){
      this.isDecreaseSkip = true;
    }

    this.currentSize = this.options.length - 1;

    if(this.isDecreaseSkip){
      this.currentSize--;
    }
    // if (isNaN(tableId)) {
    //   tableId = 0;
    // }
    if (this.isAddExistingUserComponent) {
      if (this.entityFriendlyId && this.entityUuid) {
        this.store.dispatch(
          new LoadEntityUsers(
            this.entityUuid,
            this.currentSearch,
            this.currentSize,
            this.SEARCH_PAGE_SIZE
          )
        );
      } else {
        this.store.dispatch(
          new LoadCompanyUsers(
            this.companyId,
            this.routeService.getApplicationKey(),
            this.currentSearch.length >= this.minSearchLength,
            this.currentSearch,
            true,
            this.currentSize,
            10,
            true
          )
        );
      }
    } else if (this.isSubscriptionComponent) {
      this.store.dispatch(
        new LoadUsers(
          this.routeService.getApplicationKey(),
          this.currentSearch.length >= this.minSearchLength,
          this.currentSearch,
          true,
          this.currentSize,
          10,
          true
        )
      );
    } else if (this.isRelatedDataComponent) {
      if(!this.isMoreData) return;
      var tableId = this.passedTableKey || this.routeService.getTableKey();
      this.store.dispatch(
        new GetRelatedData(
          tableId,
          this.form?.value?.FieldKey || this.relatedFieldKey,
          this.form?.value?.DropdownLabelKey || this.dropdownFieldKey || '',
          this.minSearchLength ? this.currentSearch.length >= this.minSearchLength : false,
          this.currentSearch,
          true,
          this.currentSize,
          10,
          false,
          +this.dependentFieldValue || 0,
          this.dependentFieldKey || '',
          this.restrictConditions
        )
      );
    } else {
      this.store.dispatch(
        new GetFormFieldUsers(
          tableId,
          this.routeService.getApplicationKey(),
          this.routeService?.paramMap?.formId || '',
          this.form?.value?.Id || '',
          this.currentSearch.length >= this.minSearchLength,
          this.currentSearch,
          true,
          this.currentSize,
          10,
          false,
          this.fromSMSNotification
        )
      );
    }
  }

  onSearch = (event: any) => {
    if (!this.searchable) return;
    if (this.staticOptions) return;
    this.isScrolled = false;
    this.currentSearch = event.term;
    if (event.term === '') {
      this.options = this.form?.value?.DropdownValues || (this.options.length > this.initialOptions.length ? this.options : this.initialOptions);
    } else {
      if (!this.isRelatedDataComponent && this.minSearchLength >= event.term.length) return;
      clearTimeout(this.timeout);

      if (this.isAddExistingUserComponent) {
        this.timeout = setTimeout(() => {
          if (this.entityFriendlyId && this.entityUuid) {
            this.store.dispatch(
              new LoadEntityUsers(
                this.entityUuid,
                encodeURIComponent(event.term),
                0,
                this.SEARCH_PAGE_SIZE
              )
            );
          } else {
            this.store.dispatch(
              new LoadCompanyUsers(
                this.companyId,
                this.routeService.getApplicationKey(),
                true,
                encodeURIComponent(event.term),
                false,
                0,
                0,
                true
              )
            );
          }
        }, 900);
      } else if (this.isSubscriptionComponent) {
        this.timeout = setTimeout(() => {
          this.store.dispatch(
            new LoadUsers(
              this.routeService.getApplicationKey(),
              true,
              encodeURIComponent(event.term),
              false,
              0,
              0,
              true
            )
          );
        }, 900);
      } else if (this.isRelatedDataComponent) {
        this.timeout = setTimeout(() => {
          this.options = [];
          var tableId = this.passedTableKey || this.routeService.getTableKey();
          this.store.dispatch(
            new GetRelatedData(
              tableId,
              this.form?.value?.FieldKey || this.relatedFieldKey,
              this.form?.value?.DropdownLabelKey || this.dropdownFieldKey || '',
              true,
              event.term,
              false,
              0,
              10,
              false,
              +this.dependentFieldValue || 0,
              this.dependentFieldKey || '',
              this.restrictConditions
            )
          );
        }, 900);
      } else {
        this.timeout = setTimeout(() => {
          var tableId = this.passedTableKey || this.routeService.getTableKey();
          // if (isNaN(tableId)) {
          //   tableId = 0;
          // }
          this.store.dispatch(
            new GetFormFieldUsers(
              tableId,
              this.routeService.getApplicationKey(),
              this.routeService?.paramMap?.formId || '',
              this.form?.value?.Id || '',
              true,
              encodeURIComponent(event.term),
              false,
              0,
              0,
              false,
              this.fromSMSNotification
            )
          );
        }, 900);
      }
    }
    this.scrollCount++;
  };

  onClear = (emitData: boolean = false) => {
    this.isMoreData = true;
    if(this.dependentFieldKey !== '' && this.dependentFieldValue !== 0){
      this.options = this.options.length > this.initialOptions.length ? this.options : this.initialOptions;
    } else{
      this.options = this.form?.value?.DropdownValues ? [...this.form.value.DropdownValues] : this.options.length > this.initialOptions.length ? this.options : this.initialOptions;
    }
    if (this.isFormAction &&
      this.isRelatedDataComponent &&
      this.modalLayer === 0) {
      this.options.splice(0, 0, {
        value: 'clickRelated',
        label: this.defaultSelectionLabel
          ? `Add New ${this.defaultSelectionLabel}`
          : `Add Item`,
      });
    }
    if (!this.multiple) {
      if (this.options[0]?.label !== DROPDOWN_VALUE_PLACEHOLDER && this.options[0]?.value!=='') {
        this.options.unshift({ value: '', label: DROPDOWN_VALUE_PLACEHOLDER, disabled:this.isSelectDisabled });
      }
      else{
        this.options[0] = ({ value: '', label: DROPDOWN_VALUE_PLACEHOLDER, disabled:this.isSelectDisabled });
      }
    }

    this.currentSearch = '';
    this.scrollCount = 0;
    this.form?.patchValue({ Value: this.enableFormDropdownNgSelectValue ? null : '' });
    if (typeof this?.control?.markAsDirty === 'function') {
      this.control.markAsDirty();
    }
    if (typeof this?.control?.markAsTouched === 'function') {
      this.control.markAsTouched();
    }
    this.selectionAnnouncement = this.multiple ? 'No options selected' : 'No option selected';
    if (emitData) {
      this.selected.emit({ label: '', value: '' });
    }
  };

  loadSubscribers = () => {
    if (this.isSubscriptionComponent) {
      this.subsink.add(
      this.store
        .pipe(
          select(getUsers),
          filter((users) => !!users[this.routeService.getApplicationKey()]),
          map((users) => users[this.routeService.getApplicationKey()])
        )
        .subscribe((response: any) => {
          if (response) {
            if (response == undefined) return;
            let data: any = response;
            data = data.map((d: any) => ({
              value: d.Email,
              label: d.Email,
              value2: d.Id,
            }));

            if(data.find((option:any) => option.value === this.form?.value?.Value) && this.options.find(option => option.value === this.form?.value?.Value && option.label === this.form?.value?.Value)){
              this.removedAddedValueFromOption();
            }
            if(this.currentSearch.length >= this.minSearchLength && !this.initialOptions.length){
              this.initialOptions = [...this.options];
            }
            if (this.isScrolled) {
              if (data.length > 0) data.splice(0, 1);
              let previousOptions = [...this.options];
              previousOptions.push(...data);
              this.options = previousOptions;
            } else {
              this.options = data;
              this.options.unshift({
                value:this.authService.userProfile.Email,
                label:'Current User'
              })
              if (this.options[0]?.label !== DROPDOWN_VALUE_PLACEHOLDER && this.options[0]?.value!=='') {
                this.options.unshift({ value: '', label: DROPDOWN_VALUE_PLACEHOLDER, disabled:this.isSelectDisabled });
              }
              else{
                this.options[0] = ({ value: '', label: DROPDOWN_VALUE_PLACEHOLDER, disabled:this.isSelectDisabled });
              }
            }
            this.options = this.options.filter((option:any) => option.value !== this.authService.userProfile.Email || option.label === 'Current User');
            this.options = this.removeDuplicatesByValue(this.options);
            this.updateSelectionAnnouncement();
          }
        }));
    } else if (this.isAddExistingUserComponent) {
      this.subsink.add(
      this.store
        .pipe(
          select(getApplicationById),
          filter((data) => !!data[this.routeService.getApplicationKey()]),
          map((data) => data[this.routeService.getApplicationKey()])
        )
        .subscribe((application: any) => {
          if (application) {
            this.companyId = application.CompanyKey;
          }
        }),
      this.store
        .pipe(select(getCompanyUsers))
        .subscribe((response: Array<CompanyUsers>) => {
          if (response) {
            if (response == undefined) return;
            let data: any = response;
            data = data.map((d: any) => ({
              value: d.Id,
              label: d.Email,
              value2: d.TopLevelRole,
            }));
            if(data.find((option:any) => option.value === this.form?.value?.Value) && this.options.find(option => option.value === this.form?.value?.Value && option.label === this.form?.value?.Value)){
              this.removedAddedValueFromOption();
            }
            if(this.currentSearch.length >= this.minSearchLength && !this.initialOptions.length){
              this.initialOptions = [...this.options];
            }
            if (this.isScrolled) {
              if (data.length > 0) data.splice(0, 1);
              let previousOptions = [...this.options];
              previousOptions.push(...data);
              this.options = previousOptions;
            } else {
              this.options = data;
              this.options.unshift({
                value:this.authService.userProfile.Id,
                value2:this.authService.userProfile.Role,
                label:'Current User'
              })
              if (this.options[0]?.label !== DROPDOWN_VALUE_PLACEHOLDER && this.options[0]?.value!=='') {
                this.options.unshift({ value: '', label: DROPDOWN_VALUE_PLACEHOLDER, disabled:this.isSelectDisabled });
              }
              else{
                this.options[0] = ({ value: '', label: DROPDOWN_VALUE_PLACEHOLDER, disabled:this.isSelectDisabled });
              }
            }
            this.options = this.options.filter((option:any) => option.value !== this.authService.userProfile.Email || option.label === 'Current User');
            this.options = this.removeDuplicatesByValue(this.options);
            this.updateSelectionAnnouncement();
          }
        }));
    } else if (this.isRelatedDataComponent) {
      this.subsink.add(
      this.store
        .pipe(
          select(getRelatedData),
          filter(
            (response) =>
              !!response[this.passedTableKey || this.routeService.getTableKey()] &&
              !!response[this.passedTableKey || this.routeService.getTableKey()][
              this.form?.value?.FieldKey || this.relatedFieldKey
              ]
          )
        )
        .subscribe((response: any) => {
          var tableId = this.passedTableKey || this.routeService.getTableKey();
          if (response[tableId] == undefined || this.fetchFromServer) return;

          let data = response[tableId][this.form?.value?.FieldKey || this.relatedFieldKey];

          data = data.map((d: any) => ({
            value: d.Value,
            label: d.Name,
          }));
          if(this.common.newRelatedRecordValue && data.find((option:any) => option.value === this.common.newRelatedRecordValue)){
            this.relatedSelected.emit(this.common.newRelatedRecordValue);
            this.common.newRelatedRecordValue = null;
          }

          if(data.find((option:any) => option.value === this.form?.value?.Value) && this.options.find(option => option.value === this.form?.value?.Value && option.label === this.form?.value?.Value)){
            this.removedAddedValueFromOption();
          }
          if(this.currentSearch.length && !this.initialOptions.length){
            this.initialOptions = [...this.options];
          }

          if (this.isScrolled) {
            // if (data.length > 0) data.splice(0, 1);
            if(!data.length){
              this.isMoreData = false;
            }
            let previousOptions = [...this.options];
            if (previousOptions[previousOptions.length - 1].value === 'clickRelated') {
              previousOptions.splice(previousOptions.length - 1, 1)
            }
            previousOptions.push(...data);
            this.options = previousOptions;
          } else {
            if(this.options.length){
              if (this.dependentFieldKey !== '' && this.dependentFieldValue !== 0) {
                this.options = data;
              } else {
                this.options.push(...data);
              }
              if(data.length){
                this.isMoreData = true;
              }
            } else {
              this.options = data;
            }
            if (this.options[0]?.label !== DROPDOWN_VALUE_PLACEHOLDER && this.options[0]?.value!=='') {
              this.options.unshift({ value: '', label: DROPDOWN_VALUE_PLACEHOLDER, disabled:this.isSelectDisabled });
            }
            else{
              this.options[0] = ({ value: '', label: DROPDOWN_VALUE_PLACEHOLDER, disabled:this.isSelectDisabled });
            }
            if (
              this.isFormAction &&
              this.modalLayer === 0
            ) {
              this.options.splice(1, 0, {
                value: 'clickRelated',
                label: this.defaultSelectionLabel
                  ? `Add New ${this.defaultSelectionLabel}`
                  : `Add Item`,
              });
            }
            if (this.extraOptions.length) {
              let previousOption = [...this.options];
              this.extraOptions.forEach((extraOption: any) => {
                if (!previousOption.find(option => option.value === extraOption.value)) {
                  previousOption.push(extraOption);
                }
              });
              this.options = previousOption;
            }
          }
          if (this.options[0]?.label !== DROPDOWN_VALUE_PLACEHOLDER && this.options[0]?.value!=='') {
            this.options.unshift({ value: '', label: DROPDOWN_VALUE_PLACEHOLDER, disabled:this.isSelectDisabled });
          }
          else{
            this.options[0] = ({ value: '', label: DROPDOWN_VALUE_PLACEHOLDER, disabled:this.isSelectDisabled });
          }
          if (
            this.isFormAction &&
            this.modalLayer === 0 &&
            !this.options[1].label.includes(this.defaultSelectionLabel)
          ) {
            this.options.splice(1, 0, {
              value: 'clickRelated',
              label: this.defaultSelectionLabel
                ? `Add New ${this.defaultSelectionLabel}`
                : `Add Item`,
            });
          }
          this.options = this.removeDuplicatesByValue(this.options);
          this.updateSelectionAnnouncement();
        }));
    } else if (!this.isAddExistingUserComponent && !this.staticOptions) {
      this.subsink.add(
      this.store
        .pipe(
          select(getFormFieldUsers),
          filter(
            (response) =>
              !!response[this.passedTableKey || this.routeService.getTableKey()] &&
              !!response[this.passedTableKey || this.routeService.getTableKey()][
              this.routeService?.paramMap?.formId || ''
              ] &&
              !!response[this.passedTableKey || this.routeService.getTableKey()][
              this.routeService?.paramMap?.formId || ''
              ][this.form?.value?.Id || '']
          )
        )
        .subscribe((response: any) => {
          var tableId = this.passedTableKey || this.routeService.getTableKey();
          if (response[tableId] == undefined) return;
          let data =
            response[tableId][this.routeService?.paramMap?.formId || ''][
            this.form?.value?.Id || ''
            ];
          data = data.map((d: any) => ({
            value: d.Value,
            label: d.Name,
          }));

          if(data.find((option:any) => option.value === this.form?.value?.Value) && this.options.find(option => option.value === this.form?.value?.Value && option.label === this.form?.value?.Value)){
            this.removedAddedValueFromOption();
          }
          if(this.currentSearch.length >= this.minSearchLength && !this.initialOptions.length){
            this.initialOptions = [...this.options];
          }
          if (data.length > 0) data.splice(0, 1);
          if (this.isScrolled) {
            let previousOptions = [...this.options];
            previousOptions.push(...data);
            this.options = previousOptions;
          } else {
            this.options = data;
            if(!this.fromSMSNotification || (this.fromSMSNotification && this.authService?.userProfile?.PhoneNumber && this.authService?.userProfile?.PhoneNumber!=''))
              this.options.unshift({
                value:this.authService?.userProfile?.Email,
                label:'Current User'
            })
          }
          if (this.options[0]?.label !== DROPDOWN_VALUE_PLACEHOLDER && this.options[0]?.value!=='') {
            this.options.unshift({ value: '', label: DROPDOWN_VALUE_PLACEHOLDER, disabled:this.isSelectDisabled });
          }
          else{
            this.options[0] = ({ value: '', label: DROPDOWN_VALUE_PLACEHOLDER, disabled:this.isSelectDisabled });
          }
          if (this.extraOptions?.length && !this.fromSMSNotification) {
            let previousOption = [...this.options];
            this.extraOptions.forEach((extraOption:any) => {
              if(!previousOption.find(option => option.value === extraOption.value)){
                previousOption.push(extraOption);
              }
            });
            this.options = previousOption;
          }
          this.options = this.options.filter((option:any) => option.value !== this.authService.userProfile.Email || option.label === 'Current User');
          this.options = this.removeDuplicatesByValue(this.options);
          this.updateSelectionAnnouncement();
        }));
    }
    this.cdr.detectChanges();
  };

  getUnique = (options: Array<any>): Array<any> => {
    let arr = new Array<any>();
    let str = new Array<any>();
    options.forEach((op: any, i: number) => {
      if (!str.includes(op.value)) {
        arr.push(op);
        str.push(op.value);
      }
    });
    return arr;
  };

  /**
   * Set errors here priority wise
   * @return error message
   */
  getErrorMessage = () => {
    // if (this.disabled) this.control.disable();
    if (this.control.hasError('required')) return this.error;
    return '';
  };

  fiedlDisabled() {
    if (this.isHeader || this.disabled) {
      return true;
    }
    return false;
  }

  toggleText(): void {
    this.isTextVisible = !this.isTextVisible;
  }

  handleToggleKeydown(event: KeyboardEvent): void {
    // Only handle keyboard events when accessibility flag is ON
    if (this.enableDataTableAccessibilityValue || this.enableFormDropdownNgSelectValue) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this.toggleText();
      }
    }
  }

  removeDuplicatesByValue(options: Array<any>) {
    const seenValues = new Set();
    return options.filter(item => {
      if (!seenValues.has(item.value)) {
        seenValues.add(item.value);
        return true;
      }
      return false;
    });
  }

  removedAddedValueFromOption(){
    this.options = this.options.filter(option => {
      if(
        (option.label === this.form.value.Value && option.value === this.form.value.Value) ||
        (option.label === '' && option.value === '')
      ) {
        return false;
      }
      return true;
    })
  }

  onDropdownClose(){
    this.isScrolled = false;
  }

  getFormattedLabel(value:any){
    if(this.dropdownType === 'DATE'){
      if(!value) return '';
      return moment(value)
      .format('MM/DD/yyyy');
    } else if (this.dropdownType === 'DECIMAL(20,2)'){
      if(!value) return '';
      let val = value?.toString()?.split('.');
      const isNegative = val?.[0]?.startsWith('-');
      const absoluteValue = isNegative ? val?.[0]?.slice(1) : val?.[0];
      const formattedValue = '$' + this.separator(absoluteValue) + (val?.[1] ? '.' + val[1] : '');
      return isNegative ? '-' + formattedValue : formattedValue;
    } else if(this.dropdownType === 'VARCHAR(15)' && value){
      const stringValue = value.toString();
      return stringValue.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
    } else if(this.dropdownType === 'USER' && value && value === this.authService.userProfile.Email){
      return 'Current User';
    }
    return value || '';
  }

  separator = (str: string): any => {
    if (!str || str?.length <= 3) return str;
    return (
      this.separator(str.substring(0, str.length - 3)) +
      ',' +
      str.slice(str.length - 3)
    );
  };

  detectLocalFormats(): void {
    const dateFormatter = new Intl.DateTimeFormat(undefined, {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });

    const datetimeFormatter = new Intl.DateTimeFormat(undefined, {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: 'numeric',
      minute: 'numeric',
    });

    // Detect date format
    this.localDateFormat = this.extractFormat(dateFormatter.formatToParts(new Date()));

    // Detect datetime format
    const datetimeParts = datetimeFormatter.formatToParts(new Date());
    this.localDatetimeFormat = this.extractFormat(datetimeParts);
  }

  extractFormat(parts: Intl.DateTimeFormatPart[]): string {
    return parts
      .map((part) => {
        switch (part.type) {
          case 'day':
            return 'DD';
          case 'month':
            return 'MM';
          case 'year':
            return 'YYYY';
          case 'hour':
            return 'hh'; // Use 'hh' for 12-hour format
          case 'minute':
            return 'mm';
          case 'second':
            return 'ss';
          case 'dayPeriod':
            return 'A'; // AM/PM
          default:
            return part.value; // Include separators like '/', ':' etc.
        }
      })
      .join('');
  }

  ngOnDestroy(){
    this.subsink.unsubscribe();
  }
}
